"use strict";
var zip_1 = require('../operators/zip');
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/rxjs/observable/zip.js
// module id = ../../../../rxjs/observable/zip.js
// module chunks = 5